// extracted by mini-css-extract-plugin
export default {"dashpage":"dashpage__uKZHs3","dashpageContent":"dashpageContent__EcebJB"};